<ng-container>
  <mat-form-field [style]="Control.Style" appearance="outline" *ngIf="BindingProperty" class="w-100" [id]="DomId">
    <mat-label>{{Label?(Label|translate):''}}</mat-label>
    <validation-error-tool-tip matSuffix [FormControl]="BindingProperty" [Control]="Control" [ControlType]="'select'">
    </validation-error-tool-tip>
    <mat-select [formControl]="BindingProperty" [disabled]="IsDisabled" (openedChange)="open()" (focus)="focus()"
      (selectionChange)="selectionChange($event)">
      <mat-option *ngFor="let item of DropDownList" [value]="item[ValueField]">
        {{item[TextField]}}
      </mat-option>
    </mat-select>

  </mat-form-field>
</ng-container>